import { useMemo, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { buildTheme } from "./theme/theme";
import AppShell from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import FeedPage from "./pages/FeedPage";
import PostPage from "./pages/PostPage";
import ProfilePage from "./pages/ProfilePage";
import LandingPage from "./pages/LandingPage";
import { getToken } from "./api/client";
import { AnimatePresence, motion } from "framer-motion";

function HomeRoute() {
    const token = getToken();
    return token ? <FeedPage /> : <LandingPage />;
}

const PageTransition = ({ children }: { children: React.ReactNode }) => (
    <motion.div 
        initial={{ opacity: 0, y: 10 }} 
        animate={{ opacity: 1, y: 0 }} 
        exit={{ opacity: 0, y: -10 }} 
        transition={{ duration: 0.3 }}
        style={{ width: '100%' }}
    >
        {children}
    </motion.div>
);

export default function App() {
  const [mode, setMode] = useState<"light" | "dark">(
    (localStorage.getItem("mode") as any) || "light"
  );
  const location = useLocation();

  const theme = useMemo(() => buildTheme(mode), [mode]);

  function toggleMode() {
    setMode((m) => {
      const next = m === "light" ? "dark" : "light";
      localStorage.setItem("mode", next);
      return next;
    });
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <AppShell mode={mode} toggleMode={toggleMode}>
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/login" element={<PageTransition><LoginPage /></PageTransition>} />
                <Route path="/register" element={<PageTransition><LoginPage /></PageTransition>} />
                <Route path="/" element={<PageTransition><HomeRoute /></PageTransition>} />
                <Route path="/feed" element={<PageTransition><FeedPage /></PageTransition>} />
                <Route path="/profile" element={<PageTransition><ProfilePage /></PageTransition>} />
                <Route path="/posts/:id" element={<PageTransition><PostPage /></PageTransition>} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </AnimatePresence>
        </AppShell>
    </ThemeProvider>
  );
}
